<style scoped lang='less'>
.cx-layout{position:absolute; left:0; top:0; right:0; bottom:0; padding:0; margin:0;}
/* 整体缩放 */
.cx-wrap-scale{position:absolute; left:0; top:0; width:100%; height:100%;overflow-y: scroll;overflow-x: hidden;}
#cx-scale{--scalex:1; --scaley:1;}
.cx-scale{position:absolute; left:0; top:0; transform:scale(var(--scalex), var(--scaley));}
.top-icon{position:fixed;bottom: 10px;right: 20px;float: right; z-index: 99; width: 70px;}
</style>

<template>
  <div class="cx-wrap-scale" id="cx-wrap-scale">
    <div v-wechat-title="title"></div>
    <div class="cx-layout">
      <headNav id="main" />
      <router-view></router-view>
      <img class="top-icon" @click="top" src="require('../../../../../../static/images/官网首页/top.png" alt="">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
/* 插件-主布局 */
/**
 * 罗志远 主页面布局
 */
// import auth from './auth'
import HeadNav from './HeadNav.vue'
import Footer from '.././project/Footer.vue'
import ScaleBox from '../assembly/ScaleBox.vue'
// import * as CryptoJS from 'crypto-js'
// import Encrypt from './Encrypt.js'

export default
{
  // mixins: [auth],
  components: {HeadNav, Footer, ScaleBox},
  data()
  {
    return {
      title: sessionStorage.getItem('title') || this.$route.meta.title
    }
  },
  created()
  {
  },
  methods:
  {
    top()
    {
      document.querySelector('#main') && document.querySelector('#main').scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
    // /**
    //  * 字符串转字节数组
    //  * @static
    //  * @method
    //  * @param   {String}    str               字符串
    //  * @returns {Array.<byte>}                返回字节数组
    //  */
    // strToBytes(str)
    // {
    //   const bytes = []
 
    //   for (let i = 0; i < str.length; i++)
    //     bytes.push(str.charCodeAt(i))
 
    //   return bytes
    // },
    // /**
    //  * 字节数组转字符串
    //  * @static
    //  * @method
    //  * @param   {String}    bytes             字节数组
    //  * @returns {Array.<byte>}                返回字节数组
    //  */
    // bytesToStr(bytes)
    // {
    //   const str = []
    
    //   for (let i = 0; i < bytes.length; i++)
    //     str.push(String.fromCharCode(bytes[i]))
    
    //   return str.join('')
    // },

    // /**
    //  * 系统默认登录
    //  * @method
    //  */
    // async onDefaultLogin()
    // {
    //   let params = {
    //     cmd: 'login',
    //     username: Encrypt.encrypt('admin', this.bytesToStr(this.strToBytes(window.loginKey))),
    //     password: Encrypt.encrypt('12345678', this.bytesToStr(this.strToBytes(window.loginKey))),
    //     type: 1,
    //     sys: 11
    //   }
    //   await window.post.getLogin(params).then(res =>
    //   {
    //     console.log(res)
    //     // cx.http.setAuth(res.Authorization)
    //     cx.config.initOpts.authorization = res.Authorization
    //     cx.InitRunenv.setLoginAuth({ authorization: res.Authorization, user: res.user })
    //   }).catch(e =>
    //   {
    //     console.log(e)
    //   })
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/layout/Home.vue